import { ShippingMethod, ShippingMethodType } from "@core/types";

interface FilterShippingMethodsByCartTotalProps {
  methods: ShippingMethod[];
  cartSubtotalValue: number;
  returnFreeShipping?: boolean;
}

export const filterShippingMethodsByCartTotal = ({
  methods,
  cartSubtotalValue,
  returnFreeShipping = true,
}: FilterShippingMethodsByCartTotalProps): ShippingMethod[] => {
  const freeShipping = methods.find((method) => method.methodType === ShippingMethodType.freeShipping);

  if (freeShipping && returnFreeShipping && parseFloat(freeShipping.minAmount ?? "0") <= cartSubtotalValue) {
    return [freeShipping];
  }

  return methods;
};

const getEnabledShippingMethods = (methods: ShippingMethod[]): ShippingMethod[] => {
  return methods.filter((method) => method.enabled);
};

export default getEnabledShippingMethods;
